import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { globals } from '../Globals/Globals';

const ProtectedRoute = ({ children }) => {
  
  const {isAuthenticated} = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/authent" />;
  }

  return children;
};

export default ProtectedRoute;  